import React from 'react';
import {
  ProductCarousel,
  ProductCarouselProduct,
  ProductCarouselProps,
} from '@noths/polaris-client-ribbons-design-system';

import { BlockContainer } from '../BlockContainer/BlockContainer';
import * as styles from './ProductCarouselBlock.style';

export const ProductCarouselBlock = (props: ProductCarouselProps) => (
  <BlockContainer wrapperStyles={styles.wrapper} maxWidth="max" columnsXL={10}>
    <ProductCarousel {...props} />
  </BlockContainer>
);

export type { ProductCarouselProps, ProductCarouselProduct };
